import React from 'react';
import './Profile.css';

import { PageTitle } from '../../../../components';
import { images, profile } from '../../../../constants';

import { FaEnvelope, FaMobileAlt, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';



const Profile = () => {

  // Destructure user data from props
  const {
    name,
    email,
    phone,
    profileImage,
    shippingAddress,
    billingAddress
  } = profile;

  return (
    <>

      <PageTitle title={'Profile'} page={'Profile'} />

      <section className="profile">
        <div className="box-container">
          {/* Profile Picture Area */}
          <div className="image">
            <img src={profileImage || images.profile} alt="Profile" />
          </div>

          {/* Profile Details Area */}
          <div className="profile-item profile-details">
            <div className="info">
              <h3>{name}</h3>
              <div className="container">
                <div className="box">
                  <div className="icon"><FaEnvelope /></div>
                  <span className="gmail">{email}</span>
                </div>
                <div className="box">
                  <div className="icon"><FaMobileAlt /></div>
                  <span>{phone}</span>
                </div>
                <div className="box">
                  <div className="icon"><FaMapMarkerAlt /></div>
                  <span>{billingAddress.street}</span>
                </div>
              </div>
              <Link to="/EditProfile" className="btn">edit profile</Link>
            </div>
          </div>

          {/* Address Details Area */}
          <div className="profile-item address-details">
            <div className="content">
              <div className="address-container">
                {/* Shipping Address */}
                <div className="shipping address">
                  <div className="title"><h3>shipping address</h3></div>
                  <div className="info">
                    <p><span>{shippingAddress.name || name}</span></p>
                    <p><span>country:</span> {shippingAddress.country}</p>
                    <p><span>city:</span> {shippingAddress.city}</p>
                    <p><span>province:</span> {shippingAddress.province}</p>
                    <p><span>ZIP:</span> {shippingAddress.zip}</p>
                    <p><span>address:</span> {shippingAddress.street}</p>
                  </div>
                </div>

                {/* Billing Address */}
                <div className="billing address">
                  <div className="title"><h3>billing address</h3></div>
                  <div className="info">
                    <p><span>{billingAddress.name || name}</span></p>
                    <p><span>country:</span> {billingAddress.country}</p>
                    <p><span>city:</span> {billingAddress.city}</p>
                    <p><span>province:</span> {billingAddress.province}</p>
                    <p><span>ZIP:</span> {billingAddress.zip}</p>
                    <p><span>address:</span> {billingAddress.street}</p>
                  </div>
                </div>
              </div>

              <Link to="/EditAddress" className="btn">edit address</Link>
            </div>
          </div>
        </div>
      </section>

    </>

  );
};

export default Profile;